/**
 * Booking form — tab catalogue (V2 engine).
 *
 * Pure data, no React. Drives the order and labels of the TabsList in
 * BookingFormShell. Order here = on-screen order.
 *
 * `editOnly` tabs are only inserted into the strip when editing an
 * existing booking (e.g. Activity).
 *
 * Future Phase 2 will merge a per-tenant overrides table on top of
 * this list (rename, reorder, hide). The shape stays identical so the
 * engine doesn't change.
 */
export const TABS = [
  { key: "docs",       label: "Docs"        },
  { key: "schedule",   label: "Schedule"    },
  { key: "goods",      label: "Goods"       },
  { key: "compliance", label: "Compliance"  },
  { key: "vehicle",    label: "Vehicle"     },
  { key: "driver",     label: "Driver"      },
  { key: "restraint",  label: "Restraint"   },
  { key: "qa",         label: "Site Checks" },
  // Phase 9.5 — Status: client-user-only, conditional, custom renderer.
  { key: "status",     label: "Status", clientOnly: true, custom: true },
  { key: "activity",   label: "Activity", editOnly: true },
];

export const DEFAULT_TAB = "docs";

/** Tabs the engine renders content for. Activity is mounted separately
 *  because its payload is a child component, not a registry/slot list. */
export const CONTENT_TABS = TABS.filter((t) => t.key !== "activity");
